import React from 'react';
import VisitorCounter from './VisitorCounter.tsx';

const Footer: React.FC = () => {
  return (
    <footer className="bg-white border-t border-gray-200 py-6 mt-auto">
      <div className="container mx-auto px-4">
        <div className="text-center">
          <div className="flex justify-center items-center mb-3">
            <VisitorCounter size="sm" />
          </div>
          <p className="text-sm text-gray-600">
            Designed and Developed by{' '}
            <a 
              href="https://www.websndev.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-blue-600 hover:text-blue-700 transition-colors duration-200 font-medium"
            >
              www.websndev.com
            </a>
          </p>
          <p className="text-xs text-gray-500 mt-2">
            © {new Date().getFullYear()} H2GO Water Booking. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

